import React, {createContext, useContext, useReducer} from 'react'
import {TrafficLightOverviewReducer} from "../reducer/TrafficLightOverviewReducer";
import {MODAL_RESET} from "../../../util/Constants";
import {PermissionsContext} from "../../../permissions/PermissionsContext";
import PermissionAlertBanner from "../../../commonui/PermissionAlertBanner";

export const TrafficLightDeviceOverviewContext = createContext();

const TrafficLightDeviceOverviewContextProvider = (props) => {
    const data = {
        deviceInformation: {},
        loadingOverview: true,
        showResponseModal: MODAL_RESET,
        modalMessageToDisplay: '',
    }
    const [viewModel, dispatch] = useReducer(TrafficLightOverviewReducer, data)
    const {isAuthorised} = useContext(PermissionsContext);

    if (!isAuthorised){
        return (
            <PermissionAlertBanner/>
        );
    }

    return (
        <TrafficLightDeviceOverviewContext.Provider value={{viewModel, dispatch}}>
            {props.children}
        </TrafficLightDeviceOverviewContext.Provider>
    )
}

export default TrafficLightDeviceOverviewContextProvider;


// WEBPACK FOOTER //
// ./src/components/devicemanagement/trafficlightdevice/context/TrafficLightOverviewContext.js